import { SellerEmpBidListingForm } from "../../components/seller/SellerEmpBidListingForm";
import { AuthHelper } from '../../utils/auth_helper';
import { SellerMenuTab } from '../../components/seller/SellerMenuTab'

import React from "react";
import Grid from '@mui/material/Grid';


function SellerEmpBidListing() {

  return (
    <div>
      <AuthHelper />
      <SellerMenuTab />

      <div className="tw-px-5 sm:tw-ml-20 tw-text-left">
    
          <Grid container direction="row" alignItems="center" justifyContent="" >

            <Grid container>
              <Grid item xs={12} sm={12}>
                <span className="tw-p-10 tw-text-3xl"><p>Seller New Bid Listing</p></span>
              </Grid>
            </Grid>

            <SellerEmpBidListingForm />

          </Grid>
          
      </div>

    </div>
  );

}


export { SellerEmpBidListing };
